import { 
  BalconyIcon, BbqIcon, BoxIcon, BriefcaseIcon, BusIcon, CarIcon, CheckMarkIcon, CinemaIcon, ConciergeIcon, CyclingIcon, 
  ElevatorIcon, ErrorIcon, FixIcon, GymIcon, JacuzziIcon, LaundryIcon, PetFriendlyIcon, PlaygroundIcon, RooftopTerraceIcon, 
  SaunaIcon, ShieldIcon, SmartHomeIcon, SnowIcon, SpaIcon, SwimmingIcon, TennisIcon, TreeIcon, WalkingIcon, WifiIcon
} from "@/components/icons";


export const amenityIcons: Record<string, React.FC<{ width?: number; height?: number; color?: string; className?: string }>> = {
  ac: SnowIcon,
  balcony: BalconyIcon,
  bbq: BbqIcon,
  business: BriefcaseIcon,
  car: CarIcon,
  cinema: CinemaIcon,
  concierge: ConciergeIcon,
  elevator: ElevatorIcon,
  fitness: GymIcon,
  jacuzzi: JacuzziIcon,
  laundry: LaundryIcon,
  maintenance: FixIcon,
  pet: PetFriendlyIcon,
  playground: PlaygroundIcon,
  pool: SwimmingIcon,
  sauna: SaunaIcon,
  shield: ShieldIcon,
  "smart-home": SmartHomeIcon,
  spa: SpaIcon,
  storage: BoxIcon,
  tennis: TennisIcon,
  terrace: RooftopTerraceIcon,
  tree: TreeIcon,
  wifi: WifiIcon,
};

export const transportModeIcons: Record<string, React.FC<{ width?: number; height?: number; color?: string; className?: string }>> = {
  cycling: CyclingIcon,
  driving: CarIcon,
  'public_transport': BusIcon,
  walking: WalkingIcon
}

export const indicatorIcons: Record<string, React.FC<{ width?: number; height?: number; color?: string; className?: string }>> = {
  success: CheckMarkIcon,
  error: ErrorIcon,
}